
import { Card, InlineStack, Layout, Pagination, Text, BlockStack, IndexTable, Banner, Button, Modal, Grid, Box, Select } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import { AmazonIconDark, ShopifyIconDark } from '../../../../../Asests/svgIcon/icon';
import ValueMappingSkelton from '../../skeleton/ValueMappingSkelton';
import ValueMappingModalSkelton from '../../skeleton/ValueMappingModalSkelton';
import { default as ReactSelect } from 'react-select';

import '../../styles/styles.css';
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
    infor: any;
}

const ValueMappingComponent = (props: Props): JSX.Element => {
    const { t } = useTranslation();

    const [activePage, setActivePage] = useState<number>(1);
    const [attributesActivePage, setAttributesActivePage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [attributesTotalPages, setAttributesTotalPages] = useState<number>(0);
    const [pageCount] = useState<number>(10);
    const [attributesPageCount] = useState<number>(10);
    const [attributeLoader, setAttributeLoader] = useState<boolean>(false);

    const [data, setData] = useState<any>([]);
    const [modalData, setModalData] = useState<any>({});
    const [showModal, setShowModal] = useState<any>(false);
    const [modalLoader, setModalLoader] = useState<boolean>(false);
    const [modalMarkUp, setModalMarkUp] = useState<any>({});
    const [saveLoader, setSaveLoader] = useState<boolean>(false);
    const [modalParams, setModalParams] = useState<any>({});

    const handleValueChange = (data: any, shopifyVal: any, changedVal: any) => {
        let tempModalData: any = JSON.parse(JSON.stringify(modalData))
        modalData?.mappings?.map((mapping: any, index: number) => {
            if (mapping['shopify_val'] == shopifyVal) {
                tempModalData.mappings[index]['amazon_val'] = changedVal
            }
        })
        setModalData(JSON.parse(JSON.stringify(tempModalData)))
    }

    useEffect(() => {
        let modalMarkUp: any = modalData?.mappings?.map((mapping: any, ind: any) => {
            return <Box paddingBlock="300" key={ind}>
                <Grid>
                    <Grid.Cell columnSpan={{ xs: 3, sm: 3, md: 3, lg: 6, xl: 6 }}>
                        <Text as='p' variant="bodyLg">{mapping.shopify_val}</Text>
                    </Grid.Cell>
                    <Grid.Cell columnSpan={{ xs: 3, sm: 3, md: 3, lg: 6, xl: 6 }}>
                        <ReactSelect
                            classNamePrefix="Custom__Select"
                            menuPortalTarget={document.getElementById('root')}
                            defaultValue={{ label: 'Please Select', value: '' }}
                            value={modalData?.recommendations?.filter((obj: any) => obj.value == mapping?.amazon_val)}
                            onChange={(e) => {
                                handleValueChange(modalData, mapping.shopify_val, e?.value)
                            }}
                            options={modalData?.recommendations}
                        />
                    </Grid.Cell>
                </Grid>
            </Box>
        })
        setModalMarkUp(modalMarkUp);
        setModalLoader(false);
    }, [modalData])

    useEffect(() => {
        fillDataInTable();
    }, [attributesActivePage]);

    const fillDataInTable = () => {
        setAttributeLoader(true)
        props.di.POST("amazon/listing/getValueMappingAttributes", {
            "attribute_profile_id": props.location?.state?.attributesMappingId,
            "limit": attributesPageCount,
            "page": attributesActivePage,
        }).then((res: any) => {
            if (res?.success && res?.response && Object.keys(res?.response)?.length > 0) {
                let attributesData = Object.values(res?.response).map((attribute: any) => {
                    return attribute;
                })
                setData(attributesData);
                setAttributesTotalPages(Math.ceil(res?.pagination?.['total_items'] / attributesPageCount))
            }
            else {
                props.error(t("Oops! Some error occured while getting mapped attributes."))
            }
            setAttributeLoader(false)
        })
    }

    const getRecommendations = (data: any) => {
        let recommendations = Object.keys(data)?.map((key: string) => {
            return {
                label: key,
                value: data[key]
            }
        })
        return [{ label: t("Please Select"), value: "" }, ...recommendations]
    }

    const fillAttributeValues = (shopify_attribute: any, label: any, schema_path: any, title: any) => {
        setModalLoader(true);
        props.di.POST("amazon/listing/getJsonMappedValues", {
            "attribute_profile_id": props?.location?.state?.attributesMappingId,
            "label": label,
            "product_type": props?.location?.state?.product_type,
            "limit": pageCount,
            "page": activePage,
        }).then((res: any) => {
            if (res?.success && res?.response && Object.keys(res?.response)?.length > 0) {
                let myObj: any = {
                    label,
                    shopify_attribute,
                    amazon_attribute: title,
                    recommendations: getRecommendations(res?.recommendations)
                }
                let mappings = Object.keys(res?.response).map((shopifyVal: any) => {
                    return {
                        shopify_val: shopifyVal,
                        amazon_val: res.response[shopifyVal]
                    }
                });
                myObj['mappings'] = mappings;
                setModalData(myObj);
                setTotalPages(Math.ceil(res?.pagination?.['total_items'] / pageCount))
            } else {

            }
            // setModalLoader(false);
        })
    }

    useEffect(() => {
        fillAttributeValues(modalParams?.shopify_attribute, modalParams?.label, modalParams?.schema_path, modalParams?.title)
    }, [activePage, modalParams])

    const rowMarkup = data.map(
        (
            { shopify_attribute, label, schema_path, title }: any,
            index: number,
        ) => (
            <IndexTable.Row
                id={shopify_attribute + "_" + title}
                key={shopify_attribute + "_" + title}
                // selected={selectedResources.includes(id)}
                position={index}
            >
                <IndexTable.Cell className='.value-mapping-table__item'>
                    <InlineStack gap='200'>
                        <ShopifyIconDark />
                        <Text as='p' fontWeight='regular' variant='bodyLg'>{shopify_attribute}</Text>
                    </InlineStack>
                </IndexTable.Cell>
                <IndexTable.Cell className='.value-mapping-table__item'>
                    <InlineStack gap='200'>
                        <AmazonIconDark />
                        <Text as='p' fontWeight='regular' variant='bodyLg'>{title}</Text>
                    </InlineStack>
                </IndexTable.Cell>
                <IndexTable.Cell className='value-mapping-table__item'>
                    <Button onClick={() => {
                        setModalParams({ shopify_attribute, label, schema_path, title });
                        setShowModal(true);
                        // fillAttributeValues(shopify_attribute, label, schema_path, title);
                    }} variant='primary'>{t("Map")}</Button>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    const handleChangeModal = () => {
        setActivePage(1);
        setModalData({});
        setShowModal(false);
    }

    const getOptimizedData = () => {
        let obj: any = {}
        modalData?.mappings?.forEach((mapping: any) => {
            obj[mapping['shopify_val']] = mapping['amazon_val'];
        })
        return {
            label: modalData.label,
            attribute_profile_id: props?.location?.state?.attributesMappingId,
            mapped_data: obj
        }
    }

    const handleSave = () => {
        setSaveLoader(true);
        const optimizedData = getOptimizedData()
        if (Object.keys(optimizedData.mapped_data)?.length > 0) {
            props?.di?.POST("amazon/listing/saveJsonMappedValues", { ...optimizedData }).then((res) => {
                setSaveLoader(false);
                if (res?.success) {
                    props?.success(t(res?.message) ?? t("Value Mapping saved successfully"));
                }
                else {
                    props.error(t(res?.message) ?? t(res?.code) ?? t("Oops! Some error occured while saving."))
                }
            })
        }
        else {
            props.error(t("None of the values has been edited"))
            setSaveLoader(false);
        }

    }

    return (
        <>
            <Modal
                open={showModal}
                onClose={handleChangeModal}
                title={t("Map Shopify values with Amazon")}
                primaryAction={{
                    content: t('Save'),
                    onAction: handleSave,
                    loading: saveLoader
                }}
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: handleChangeModal,
                    },
                ]}
            >
                <Modal.Section>
                    {modalLoader ? <ValueMappingModalSkelton /> : <BlockStack gap="600">
                        {/* <TextField
                            label
                            placeholder='Search'
                            prefix={<Icon source={SearchMinor} tone="base" />}
                            value={'value'}
                            onChange={handleChange}
                            autoComplete="off"
                        /> */}
                        <BlockStack gap="500">
                            {/* <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} /> */}
                            <BlockStack gap="0">
                                <div className="custom-grid_header">
                                    <Grid>
                                        <Grid.Cell columnSpan={{ xs: 3, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                            <BlockStack gap="150">
                                                <Text as='p' variant="bodySm" tone='subdued'>{t("Shopify Attribute")}</Text>
                                                <InlineStack gap='200'>
                                                    <ShopifyIconDark />
                                                    <Text as='p' fontWeight='medium' variant='bodyLg'>{modalData?.shopify_attribute}</Text>
                                                </InlineStack>
                                            </BlockStack>
                                        </Grid.Cell>
                                        <Grid.Cell columnSpan={{ xs: 3, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                            <BlockStack gap="150">
                                                <Text as='p' variant="bodySm" tone='subdued'>{t("Corresponding Amazon Attribute")}</Text>
                                                <InlineStack gap='200'>
                                                    <AmazonIconDark />
                                                    <Text as='p' fontWeight='medium' variant='bodyLg'>{modalData?.amazon_attribute}</Text>
                                                </InlineStack>
                                            </BlockStack>
                                        </Grid.Cell>
                                    </Grid>
                                </div>
                                <div className='custom-grid__wrap'>
                                    {modalMarkUp}
                                    {!modalLoader && <Box paddingBlockStart="300">
                                        <InlineStack align="center" gap="400">
                                            <Pagination
                                                label={
                                                    <Text as='p' variant="bodyLg">{`${activePage}/${totalPages}`}</Text>
                                                }
                                                hasPrevious={activePage > 1}
                                                hasNext={activePage < totalPages}
                                                onNext={() => {
                                                    setActivePage(page => page + 1)
                                                }}
                                                onPrevious={() => {
                                                    setActivePage(page => page - 1)
                                                }}
                                            />
                                        </InlineStack>
                                    </Box>}
                                </div>
                            </BlockStack>
                        </BlockStack>
                    </BlockStack>}
                </Modal.Section>
            </Modal>
            <Card padding="500">
                <Layout>
                    <Layout.Section variant="oneThird">
                        <BlockStack gap="600">
                            <BlockStack gap="200">
                                <Text variant="headingMd" as="h2">
                                    {t("Value Mapping")}
                                </Text>
                                <Text tone="subdued" as="p">
                                    {t("Select values matching to corresponding Amazon attribute values.")}
                                    {/* Know more on <Link url='#'>how to map correct values</Link>. */}
                                </Text>
                            </BlockStack>
                            {/* <Badge icon={InfoMinor} tone='info' size='large'>50 Attributes are yet to be mapped</Badge> */}
                        </BlockStack>
                    </Layout.Section>
                    <Layout.Section>
                        <BlockStack gap="500">
                            <BlockStack gap="300">
                                <Text as='p' tone='subdued' variant='bodySm'>{t("Map shopify values of attributes with corresponding values of Amazon attributes")}</Text>
                                {/* <AutoCompleteSearch /> */}
                            </BlockStack>
                            <Card padding={'0'}>
                                {attributeLoader ? <ValueMappingSkelton /> : <IndexTable
                                    key={'JSONValueMapping'}
                                    resourceName={{
                                        singular: 'attribute',
                                        plural: 'attributes',
                                    }}
                                    itemCount={4}
                                    headings={[{ title: t('Shopify attributes'), id: 'shopify_attribute' },
                                    { title: t('Amazon Attributes'), id: 'amazon_attribute' },
                                    { title: t('Action'), id: 'action' },
                                    ]}
                                    selectable={false}
                                    emptyState={<Banner tone='warning'>{t("No variant(s) found")}</Banner>}
                                >
                                    {rowMarkup}
                                </IndexTable>}
                            </Card>
                            {!attributeLoader && <InlineStack align="center" gap="400">
                                <Pagination
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div className="Polaris-TextField">
                                                <input
                                                    className="psedu-polaris-textfield Polaris-TextField__Input Polaris-TextField__Input--alignCenter"
                                                    style={{ maxWidth: '45px' }}
                                                    type='number'
                                                    min="1"
                                                    placeholder={'placeholder'}
                                                    value={attributesActivePage}
                                                />
                                                <div className="Polaris-TextField__Backdrop"></div>
                                            </div>
                                            <div style={{ margin: '0 0 0 10px' }}>
                                                <Text as='span' tone="subdued">{` / ${attributesTotalPages}`}</Text>
                                            </div>
                                        </div>
                                    }
                                    hasPrevious={attributesActivePage > 1}
                                    hasNext={attributesActivePage < attributesTotalPages}
                                    onNext={() => {
                                        setAttributesActivePage(page => page + 1);
                                    }}
                                    onPrevious={() => {
                                        setAttributesActivePage(page => page - 1)
                                    }}
                                />
                            </InlineStack>}
                        </BlockStack>
                    </Layout.Section>
                </Layout>
            </Card>
        </>
    );
}

export default DI(ValueMappingComponent);

